<!-- src/views/XangDau/BaoCaoXangDauMobile.vue -->
<template>
  <div class="page-wrapper fuel-report-page">
    <div class="content container-fluid pb-5 pb-bottom-nav">
      <!-- HEADER -->
      <div class="page-header mb-2">
        <div class="d-flex flex-wrap justify-content-between align-items-center">
          <div>
            <h3 class="page-title mb-1">Báo cáo Xăng Dầu</h3>
            <small class="text-muted">
              Tổng quan tiêu hao & hiệu suất theo bộ lọc
            </small>
          </div>

          <div class="d-none d-md-flex flex-column align-items-end small-header-stats">
            <div class="header-stat-pill">
              <span class="label">Số lần đổ</span>
              <span class="value">{{ fmtNumber(summary.soLanDo) }}</span>
            </div>
            <div class="header-stat-pill">
              <span class="label">Tổng lít</span>
              <span class="value">{{ fmtNumber(summary.tongLit) }} L</span>
            </div>
          </div>
        </div>
      </div>

      <!-- DESKTOP TAB NAV -->
      <div class="card mb-2 d-none d-md-block">
        <div class="card-body py-2">
          <div class="btn-group btn-group-sm" role="group">
            <button
              type="button"
              class="btn"
              :class="activeTab === 'OVERVIEW' ? 'btn-primary' : 'btn-outline-primary'"
              @click="activeTab = 'OVERVIEW'"
            >
              <i class="fa fa-pie-chart mr-2"></i> Tổng quan
            </button>

            <button
              type="button"
              class="btn"
              :class="activeTab === 'DETAIL' ? 'btn-primary' : 'btn-outline-primary'"
              @click="activeTab = 'DETAIL'"
            >
              <i class="fa fa-list-ul mr-2"></i> Danh sách
            </button>

            <button
              type="button"
              class="btn"
              :class="activeTab === 'CAU' ? 'btn-primary' : 'btn-outline-primary'"
              @click="activeTab = 'CAU'"
            >
              <i class="fa fa-industry mr-2"></i> Cẩu
            </button>
          </div>
        </div>
      </div>

      <!-- FILTER BLOCK -->
      <div class="card mb-2">
        <div class="card-body p-2">
          <form @submit.prevent="refreshAll" class="row g-2 align-items-end">
            <!-- Xe -->
            <div class="col-12 col-md-4">
              <label class="form-label mb-1">Xe</label>
              <select
                v-model="filters.xeId"
                class="form-control form-control-sm"
                :disabled="isLoadingOptions"
              >
                <option :value="null">Tất cả xe</option>
                <option v-for="x in xeOptions" :key="x.id" :value="x.id">
                  {{ x.bienSo }}
                </option>
              </select>
            </div>

            <!-- Chế độ thời gian -->
            <div class="col-12 col-md-4">
              <label class="form-label mb-1">Chế độ thời gian</label>
              <div class="btn-group btn-group-sm d-flex" role="group">
                <button
                  type="button"
                  class="btn"
                  :class="filterMode === 'MONTH' ? 'btn-primary' : 'btn-outline-primary'"
                  @click="setFilterMode('MONTH')"
                >
                  Theo tháng
                </button>
                <button
                  type="button"
                  class="btn"
                  :class="filterMode === 'DATE_RANGE' ? 'btn-primary' : 'btn-outline-primary'"
                  @click="setFilterMode('DATE_RANGE')"
                >
                  Khoảng ngày
                </button>
              </div>
            </div>

            <!-- Tháng -->
            <div v-if="filterMode === 'MONTH'" class="col-12 col-md-4">
              <label class="form-label mb-1">Tháng</label>
              <div class="d-flex align-items-center">
                <button
                  type="button"
                  class="btn btn-light btn-sm mr-1"
                  @click="changeMonth(-1)"
                >
                  <i class="fa fa-chevron-left"></i>
                </button>
                <input
                  v-model="monthInput"
                  type="month"
                  class="form-control form-control-sm"
                  @change="onMonthChange"
                />
                <button
                  type="button"
                  class="btn btn-light btn-sm ml-1"
                  @click="changeMonth(1)"
                >
                  <i class="fa fa-chevron-right"></i>
                </button>
              </div>
            </div>

            <!-- Khoảng ngày -->
            <div v-if="filterMode === 'DATE_RANGE'" class="col-6 col-md-2">
              <label class="form-label mb-1">Từ ngày</label>
              <input
                v-model="filters.tuNgay"
                type="date"
                class="form-control form-control-sm"
              />
            </div>
            <div v-if="filterMode === 'DATE_RANGE'" class="col-6 col-md-2">
              <label class="form-label mb-1">Đến ngày</label>
              <input
                v-model="filters.denNgay"
                type="date"
                class="form-control form-control-sm"
              />
            </div>

            <div class="col-12 col-md-2 ml-md-auto mt-1">
              <button
                type="submit"
                class="btn btn-primary btn-sm w-100"
                :disabled="isLoadingSummary"
              >
                <span
                  v-if="isLoadingSummary"
                  class="spinner-border spinner-border-sm mr-1"
                ></span>
                Lọc & tính lại
              </button>
            </div>
          </form>
        </div>
      </div>

      <!-- MAIN CONTENT TABS -->
      <div v-if="activeTab === 'OVERVIEW'">
        <!-- OVERVIEW CARDS -->
        <div class="row mb-2">
          <div class="col-6 col-md-3 mb-2" v-for="card in overviewCards" :key="card.key">
            <div class="stat-card">
              <div class="stat-label">{{ card.label }}</div>
              <div class="stat-value" :class="card.class">
                {{ card.display }}
              </div>
            </div>
          </div>
        </div>

        <!-- SUMMARY TABLE + EXPORT -->
        <div class="card mb-3">
          <div
            class="card-header d-flex justify-content-between align-items-center py-2 px-3"
          >
            <div class="small font-weight-bold">
              <i class="fa fa-bar-chart mr-1"></i>
              Báo cáo tổng quan
            </div>
            <button
              type="button"
              class="btn btn-sm btn-outline-success"
              @click="exportSummaryExcel"
              :disabled="isLoadingSummary"
            >
              <i class="fa fa-file-excel-o mr-1"></i> Excel tổng quan
            </button>
          </div>
          <div class="card-body p-2">
            <table class="table table-sm mb-0 summary-table">
              <tbody>
<tr>
  <td>Tổng Km đã đi (ODO)</td>
  <td class="text-right font-weight-bold text-primary">
    {{ fmtNumber(summary.tongKmDaDi, 1) }} km
  </td>
</tr>

<tr>
  <td>Tổng Km định vị (GPS)</td>
  <td class="text-right font-weight-bold text-info">
    {{ fmtNumber(summary.tongKmDinhVi, 1) }} km
  </td>
</tr>

<tr>
  <td>Tổng Km phải đi (quy đổi)</td>
  <td class="text-right font-weight-bold">
    {{ fmtNumber(summary.tongKmPhaiDi, 1) }} km
  </td>
</tr>

<tr>
  <td>Hiệu suất Km/Lít (chỉ ODO)</td>
  <td class="text-right font-weight-bold text-success">
    {{ fmtNumber(summary.kmPerLit, 2) }} km/L
  </td>
</tr>

<tr>
  <td>Tổng Km cẩu (quy đổi)</td>
  <td class="text-right font-weight-bold text-primary">
    {{ fmtNumber(summary.tongKmCauQuyDoi, 1) }} km
  </td>
</tr>

<tr>
  <td>Tổng Km thực tế (chạy + cẩu)</td>
  <td class="text-right font-weight-bold text-success">
    {{ fmtNumber(summary.tongKmDaDiWithCau, 1) }} km
  </td>
</tr>

<tr>
  <td>Hiệu suất Km/Lít (bao gồm cẩu)</td>
  <td class="text-right font-weight-bold text-success">
    {{ fmtNumber(summary.kmPerLitWithCau, 2) }} km/L
  </td>
</tr>

                <tr>
                  <td>Số lần giao hàng</td>
                  <td class="text-right font-weight-bold">
                    {{ fmtNumber(summary.soLanGiaoHang) }}
                  </td>
                </tr>
                <tr>
                  <td>Số lần lấy hàng</td>
                  <td class="text-right font-weight-bold">
                    {{ fmtNumber(summary.soLanLayHang) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="small text-muted">
          Tổng số log trong kỳ:
          <strong>{{ fmtNumber(totalLogs) }}</strong>
        </div>
      </div>

      <!-- DETAIL LIST TAB -->
      <div v-else-if="activeTab === 'DETAIL'">
        <div v-if="isLoadingSummary" class="p-3 text-center text-muted">
          <span class="spinner-border spinner-border-sm mr-1"></span>
          Đang tải dữ liệu...
        </div>
        <div v-else-if="listError" class="alert alert-danger p-2">
          {{ listError }}
        </div>
        <div v-else-if="!logs.length" class="p-3 text-center text-muted">
          Không có log xăng dầu trong khoảng thời gian này.
        </div>
        <div v-else>
          <div
            v-for="log in logs"
            :key="log.id"
            class="fuel-log-card"
          >
            <div class="d-flex justify-content-between">
              <div>
                <div class="log-car">{{ log.xeBienSo }}</div>
                <div class="log-driver small text-muted">
                  {{ log.tenTaiXe || 'Tài xế ?' }}
                </div>
              </div>
              <div class="text-right">
                <div class="log-money">
                  {{ formatCurrency(log.soTien) }}
                </div>
                <div class="small text-muted">
                  {{ Number(log.soLit || 0).toLocaleString('vi-VN') }} L
                </div>
              </div>
            </div>

            <div class="d-flex justify-content-between mt-1 small">
              <div>
                {{ shortDate(log.ngayDo) }}
              </div>
              <div class="text-right">
                <span class="mr-1">Km:</span>
                <strong>
                  {{ Number(perLogKm[log.id] || 0).toLocaleString('vi-VN') }}
                </strong>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- CAU TAB -->
      <div v-else-if="activeTab === 'CAU'">
        <div class="alert alert-info p-2 small">
          <div v-if="isSelectedXeCau" class="card mt-2">
            <div class="card-body py-2">
              <div class="d-flex justify-content-between align-items-center mb-1">
                <div class="font-weight-bold">
                  <i class="fa fa-industry mr-1"></i>
                  Cẩu hàng (quy đổi)
                </div>
                <div>
                  <small v-if="isLoadingCauSummary || isLoadingCauSessions" class="text-muted">
                    <span class="spinner-border spinner-border-sm"></span> Đang tải...
                  </small>
                  <small v-else-if="cauSummaryError || cauSessionsError" class="text-danger">
                    {{ cauSummaryError || cauSessionsError }}
                  </small>
                </div>
              </div>

              <div v-if="!isLoadingCauSummary && !cauSummaryError">
                <div class="row small text-center">
                  <div class="col-4 mb-1">
                    <div class="text-muted">Giờ cẩu</div>
                    <div class="font-weight-bold">
                      {{ fmtNumber((cauSummary && cauSummary.totalMinutes || 0) / 60, 1) }} h
                    </div>
                  </div>
                  <div class="col-4 mb-1">
                    <div class="text-muted">Lít (quy đổi)</div>
                    <div class="font-weight-bold">
                      {{
                        fmtNumber(
                          (cauSummary &&
                            (cauSummary.estimatedLiters ??
                             cauSummary.totalLit ??
                             cauSummary.totalFuelLit)) || 0,
                          1
                        )
                      }} L
                    </div>
                  </div>
                  <div class="col-4 mb-1">
                    <div class="text-muted">Km cẩu</div>
                    <div class="font-weight-bold text-primary">
                      {{ fmtNumber(kmCauFromSummary, 1) }} km
                    </div>
                  </div>
                </div>

                <div class="small text-muted mt-1 text-center">
                  Km thực tế (chạy + cẩu):
                  <strong class="text-success">
                    {{ fmtNumber(summary.tongKmDaDiWithCau, 1) }} km
                  </strong><br />
                </div>
              </div>

              <!-- LỊCH SỬ PHIÊN CẨU -->
              <div class="mt-3">
                <div class="font-weight-bold mb-1">
                  <i class="fa fa-history mr-1"></i>
                  Phiên cẩu trong kỳ
                </div>

                <div v-if="isLoadingCauSessions" class="text-muted">
                  <span class="spinner-border spinner-border-sm mr-1"></span>
                  Đang tải danh sách phiên cẩu...
                </div>

                <div v-else-if="cauSessionsError" class="text-danger">
                  {{ cauSessionsError }}
                </div>

                <div v-else-if="!cauSessions.length" class="text-muted">
                  Không có phiên cẩu nào trong khoảng thời gian này.
                </div>

                <div v-else>
                  <div
                    v-for="s in cauSessions"
                    :key="s.id"
                    class="cau-session-item"
                  >
                    <div class="d-flex justify-content-between align-items-start">
                      <div class="small">
                        <strong>#{{ s.id }}</strong>
                        <div class="text-muted mt-1">
                          {{ formatDateTime(s.startedAt || s.createdAt) }}
                          <span v-if="s.endedAt">
                            → {{ formatDateTime(s.endedAt) }}
                          </span>
                          <span v-else class="text-danger"> (chưa đóng)</span>
                        </div>
                      </div>

                      <div class="text-right small text-muted">
                        {{ fmtNumber(s.durationMinutes || 0) }} phút
                      </div>
                    </div>

                    <!-- IMAGES -->
                    <div v-if="s.imgStartUrl || s.imgEndUrl" class="cau-img-row mt-2">
  <div class="cau-img-col" v-if="s.imgStartUrl">
    <div class="cau-img-label text-muted">Mở cẩu</div>
    <img
      :src="s.imgStartUrl"
      class="cau-img"
      loading="lazy"
      @click="openCauLightbox(s, 'start')"
      alt="Ảnh mở cẩu"
    />
  </div>

  <div class="cau-img-col" v-if="s.imgEndUrl">
    <div class="cau-img-label text-muted">Đóng cẩu</div>
    <img
      :src="s.imgEndUrl"
      class="cau-img"
      loading="lazy"
      @click="openCauLightbox(s, 'end')"
      alt="Ảnh đóng cẩu"
    />
  </div>
</div>


                    <div v-else class="small text-muted mt-2">
                      Không có ảnh.
                    </div>
                  </div>

                  <!-- IMAGE PREVIEW MODAL -->
                  <div v-if="imgPreview.show" class="img-modal" @click.self="closeImg">
                    <div class="img-modal-card">
                      <div class="img-modal-head">
                        <div class="font-weight-bold">{{ imgPreview.title }}</div>
                        <button class="btn btn-sm btn-light" @click="closeImg">
                          <i class="fa fa-times"></i>
                        </button>
                      </div>
                      <div class="img-modal-body">
                        <img :src="imgPreview.url" class="img-modal-img" alt="preview" />
                        <a
                          class="btn btn-sm btn-outline-primary mt-2"
                          :href="imgPreview.url"
                          target="_blank"
                          rel="noopener"
                        >
                          <i class="fa fa-external-link mr-1"></i> Mở tab mới
                        </a>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <div v-else class="text-muted">
            Chọn 1 xe cẩu ở bộ lọc để xem thống kê quy đổi & lịch sử từng phiên cẩu.
          </div>
        </div>
      </div>
    </div>

    <!-- BOTTOM NAV (MOBILE) -->
    <nav class="bottom-nav d-md-none">
      <button
        class="bottom-nav-item"
        :class="{ active: activeTab === 'OVERVIEW' }"
        @click="activeTab = 'OVERVIEW'"
      >
        <i class="fa fa-pie-chart"></i>
        <span>Tổng quan</span>
      </button>
      <button
        class="bottom-nav-item"
        :class="{ active: activeTab === 'DETAIL' }"
        @click="activeTab = 'DETAIL'"
      >
        <i class="fa fa-list-ul"></i>
        <span>Danh sách</span>
      </button>
      <button
        class="bottom-nav-item"
        :class="{ active: activeTab === 'CAU' }"
        @click="activeTab = 'CAU'"
      >
        <i class="fa fa-industry"></i>
        <span>Cẩu</span>
      </button>
    </nav>

  </div>
  <VueEasyLightbox
  :visible="lightbox.visible"
  :imgs="lightbox.imgs"
  :index="lightbox.index"
  @hide="closeLightbox"
/>

</template>
<script>
import { mapState, mapActions } from 'pinia';
import { useAdminXangDauStore } from '@/stores/adminXangDauStore';
import * as XLSX from 'xlsx-js-style';
import { XangDauApi } from '@/services/xangDauService';
import { formatDateTime } from '@/helpers/datetime';
const MAX_GPS_RANGE_MS = 3 * 24 * 60 * 60 * 1000; // 3 ngày
import VueEasyLightbox from 'vue-easy-lightbox';

function formatCurrency(value) {
  if (value == null || isNaN(Number(value))) return '-';
  return Number(value).toLocaleString('vi-VN') + ' đ';
}

export default {
  name: 'BaoCaoXangDauMobile',
  components: { VueEasyLightbox },

  data() {
    return {
      filters: {
        xeId: null,
        tuNgay: null,
        denNgay: null,
      },
      filterMode: 'MONTH',
      monthInput: null,

      activeTab: 'OVERVIEW',

      isLoadingSummary: false,

      // base summary (không cẩu)
      summaryBase: {
        soLanDo: 0,
        tongTien: 0,
        tongLit: 0,
        tongLitThucDung: 0,
        tongKmDaDi: 0,
        tongKmPhaiDi: 0,
        tongKmDinhVi: 0,
        soLanGiaoHang: 0,
        soLanLayHang: 0,
        kmPerLit: 0,
      },

      logs: [],
      perLogKm: {}, // id -> km fallback (tính từ ODO)
      totalLogs: 0,

      cauSummary: null,
      isLoadingCauSummary: false,
      cauSummaryError: null,

      cauSessions: [],
      isLoadingCauSessions: false,
      cauSessionsError: null,
      // ===== GPS SUMMARY =====
      gpsConfig: {
        username: '61h06971\u2003',
        password: '12345',
      },
      isLoadingGps: false,
      gpsError: null,
          tonDau: null,

      imgPreview: {
        show: false,
        url: null,
        title: '',
      },

      lightbox: {
  visible: false,
  imgs: [],
  index: 0,
  title: '',
},


    };
  },
  computed: {
    ...mapState(useAdminXangDauStore, ['isLoadingOptions', 'xeOptions', 'listError']),

    selectedXe() {
      if (!this.filters.xeId || !this.xeOptions) return null;
      return this.xeOptions.find((x) => x.id === this.filters.xeId) || null;
    },

    isSelectedXeCau() {
      return this.isCauXeOption(this.selectedXe);
    },

    kmCauFromSummary() {
      if (!this.cauSummary) return 0;

      const KM_PER_LITER = 4;
      const FUEL_PER_HOUR = 5;

      const totalLit = Number(
        this.cauSummary.estimatedLiters ??
          this.cauSummary.totalLit ??
          this.cauSummary.totalFuelLit ??
          0,
      );

      let km = 0;

      if (totalLit > 0) {
        km = totalLit * KM_PER_LITER;
      } else {
        const minutes = Number(this.cauSummary.totalMinutes || 0);
        if (minutes > 0) {
          const hours = minutes / 60;
          const litFromHours = hours * FUEL_PER_HOUR;
          km = litFromHours * KM_PER_LITER;
        }
      }

      return Number.isFinite(km) ? km : 0;
    },

    // summary cuối cùng: base + cẩu + lít thực dụng
summary() {
  const baseDefaults = {
    soLanDo: 0,
    tongTien: 0,
    tongLit: 0,
    tongLitThucDung: 0,
    tongKmDaDi: 0,
    tongKmPhaiDi: 0,
    tongKmDinhVi: 0,
    soLanGiaoHang: 0,
    soLanLayHang: 0,
    kmPerLit: 0,
  };

  const base = this.summaryBase || baseDefaults;
  const kmCau = this.kmCauFromSummary;

  const tongKmDaDiWithCau = base.tongKmDaDi + kmCau;

  // Lít dùng để tính Km/L: ưu tiên lít thực dụng
  const litForCalc =
    Number(base.tongLitThucDung || 0) > 0
      ? Number(base.tongLitThucDung)
      : Number(base.tongLit || 0);

  const kmPerLit = litForCalc > 0 ? base.tongKmDaDi / litForCalc : 0;
  const kmPerLitWithCau = litForCalc > 0 ? tongKmDaDiWithCau / litForCalc : 0;

  return {
    ...base,
    tongLitForCalc: litForCalc,          // dùng cho UI & Excel
    tongKmCauQuyDoi: kmCau,              // km cẩu quy đổi
    tongKmDaDiWithCau,                   // km chạy + cẩu
    kmPerLit,
    kmPerLitWithCau,                     // hiệu suất có cộng cẩu
  };
},


overviewCards() {
  return [
    {
      key: 'soLanDo',
      label: 'Số lần đổ',
      class: '',
      display: this.fmtNumber(this.summary.soLanDo),
    },
    {
      key: 'tongTien',
      label: 'Tổng tiền',
      class: 'text-danger',
      display: formatCurrency(this.summary.tongTien),
    },
    {
      key: 'tongLit',
      label: 'Tổng lít',
      class: '',
      display:
        this.fmtNumber(
          this.summary.tongLitThucDung || this.summary.tongLit,
        ) + ' L',
    },
    {
      key: 'kmPerLit',
      label: 'Km/Lít (ODO)',
      class: 'text-success',
      display: this.fmtNumber(this.summary.kmPerLit, 2),
    },
    {
      key: 'kmGps',
      label: 'Km định vị',
      class: 'text-info',
      display: this.fmtNumber(this.summary.tongKmDinhVi, 1) + ' km',
    },
  ];
},

  },
  methods: {
    ...mapActions(useAdminXangDauStore, ['fetchOptionsIfNeeded']),

    normalizePlate(plate) {
  if (!plate) return '';
  return plate.replace(/\s|\./g, '');
},
     // ====== GPS / KM ĐỊNH VỊ TỔNG ======
    toLocalGpsTime(dateOrString) {
      const d =
        dateOrString instanceof Date ? dateOrString : new Date(dateOrString);
      if (Number.isNaN(d.getTime())) return '';

      const yyyy = d.getFullYear();
      const MM = String(d.getMonth() + 1).padStart(2, '0');
      const dd = String(d.getDate()).padStart(2, '0');
      const hh = String(d.getHours()).padStart(2, '0');
      const mm = String(d.getMinutes()).padStart(2, '0');

      return `${yyyy}-${MM}-${dd} ${hh}:${mm}:00`;
    },

    async fetchGpsChunk(plate, beginTime, endTime) {
      const baseUrl = 'https://api.gpsbinhminh.vn/Vehicle/GpsHistoryV3';

      const plateDemo = this.normalizePlate(plate);


      const params = new URLSearchParams({
        licensePlate: plateDemo,
        beginTime,
        endTime,
        username: this.gpsConfig.username,
        pwd: this.gpsConfig.password,
      });

      const res = await fetch(`${baseUrl}?${params.toString()}`);
      const text = await res.text();

      if (!text || !text.trim()) {
        return { km: 0, rawBegin: null, rawEnd: null };
      }

      let json;
      try {
        json = JSON.parse(text);
      } catch (e) {
        console.error('[GPS] parse error:', e, text);
        throw new Error('GPS lỗi JSON');
      }

      const list = Array.isArray(json.Data) ? json.Data : [];
      if (!list.length) {
        return { km: 0, rawBegin: null, rawEnd: null };
      }

      const first = list[0];
      const last = list[list.length - 1];

      const startTotal = Number(first.TotalDistance || 0);
      const endTotal = Number(last.TotalDistance || 0);

      let delta = endTotal - startTotal;
      if (!Number.isFinite(delta) || delta < 0) delta = 0;

      return {
        km: delta / 1000,
        rawBegin: first.UpdateTime || null,
        rawEnd: last.UpdateTime || null,
      };
    },

    // Tính tổng km định vị cho cả khoảng ngày đang lọc
    async fetchGpsTotalForRange(plate, startDate, endDate) {
  let totalKm = 0;
  let segStart = new Date(startDate);

  while (segStart < endDate) {
    let segEnd = new Date(segStart.getTime() + MAX_GPS_RANGE_MS - 60 * 1000);
    if (segEnd > endDate) segEnd = endDate;

    const beginTime = this.toLocalGpsTime(segStart); // y-m-d H:i:s
    const endTime   = this.toLocalGpsTime(segEnd);

    const chunk = await this.fetchGpsChunk(plate, beginTime, endTime);
    if (chunk && chunk.km != null) {
      totalKm += chunk.km;
    }

    segStart = new Date(segEnd.getTime() + 60 * 1000);
  }

  return totalKm;
},

    async refreshGpsSummary() {
  this.summaryBase.tongKmDinhVi = 0;

  // phải có xe & log
  if (!this.filters.xeId || !this.selectedXe) return;

  const range = this.getGpsRange();
  if (!range) return;

  const plate = this.selectedXe.bienSo;
  const { start, end } = range;

  try {
    const totalKm = await this.fetchGpsTotalForRange(plate, start, end);
    this.summaryBase = {
      ...this.summaryBase,
      tongKmDinhVi: totalKm,
    };
      } catch (e) {
        console.error('[BaoCaoXangDauMobile] refreshGpsSummary error', e);
        this.gpsError =
          e?.message || 'Không tính được Km định vị từ GPS.';
        this.summaryBase = {
          ...this.summaryBase,
          tongKmDinhVi: 0,
        };
      } finally {
        this.isLoadingGps = false;
      }
    },

    fmtNumber(value, fractionDigits = 0) {
      const n = Number(value);
      if (!Number.isFinite(n)) return '0';
      return n.toLocaleString('vi-VN', {
        maximumFractionDigits: fractionDigits,
      });
    },

    isCauXeOption(xe) {
      if (!xe) return false;
      const loaiRaw = (xe.loaiXe || '').toString().toLowerCase();
      const tenLoaiRaw = (xe.tenLoaiXe || '').toString().toLowerCase();
      return (
        loaiRaw === 'cau' ||
        tenLoaiRaw.includes('cẩu') ||
        tenLoaiRaw.includes('cau') ||
        !!xe.isCau
      );
    },

    // Log kỹ thuật dùng để chốt tồn / chỉnh ODO, không tính vào báo cáo
    isChotTonLog(log) {
      if (!log) return false;
      const lit = Number(log.soLit || 0);
      const money = Number(log.soTien || 0);
      // Rule tạm: log chốt tồn thường 1 lít, 1 đồng
      return lit <= 1 && money <= 1;
    },

    async loadCauData() {
      // reset state
      this.cauSummary = null;
      this.cauSummaryError = null;
      this.cauSessions = [];
      this.cauSessionsError = null;

      const xeId = this.filters.xeId;
      if (!xeId) return;

      const xe = this.selectedXe;
      // nếu không phải xe cẩu thì khỏi gọi API cẩu
      if (!this.isCauXeOption(xe)) {
        return;
      }

      const params = {
        xeId,
        tuNgay: this.filters.tuNgay || null,
        denNgay: this.filters.denNgay || null,
      };

      this.isLoadingCauSummary = true;
      this.isLoadingCauSessions = true;
      this.cauSummaryError = null;
      this.cauSessionsError = null;

      try {
        const [summary, sessions] = await Promise.all([
          XangDauApi.getCauFuelSummary(params),
          XangDauApi.listCauByXe(params),
        ]);

        this.cauSummary = summary || null;
        this.cauSessions = Array.isArray(sessions) ? sessions : [];
      } catch (e) {
        console.error('[BaoCaoXangDauMobile] loadCauData error', e);
        const msg =
          e?.response?.data?.message ||
          e?.message ||
          'Không tải được dữ liệu cẩu hàng.';
        this.cauSummaryError = msg;
        this.cauSessionsError = msg;
      } finally {
        this.isLoadingCauSummary = false;
        this.isLoadingCauSessions = false;
      }
    },

    openImg(url, title = '') {
  if (!url) return;
  this.imgPreview = { show: true, url, title };
},

closeImg() {
  this.imgPreview = { show: false, url: null, title: '' };
},

onImgError(e) {
  // khỏi làm trò gì nhiều, đừng để ảnh vỡ UI
  if (e?.target) e.target.style.display = 'none';
    },

openCauLightbox(session, which) {
  // which: 'start' | 'end' | null (mở theo ảnh được click)
  const list = [];
  if (session?.imgStartUrl) list.push(session.imgStartUrl);
  if (session?.imgEndUrl) list.push(session.imgEndUrl);

  if (!list.length) return;

  let index = 0;
  if (which === 'end' && session?.imgEndUrl) index = list.length - 1;

  this.lightbox = {
    visible: true,
    imgs: list,
    index,
    title: `Phiên cẩu #${session?.id || ''}`,
  };
},

closeLightbox() {
  this.lightbox.visible = false;
},

    isCanceled(log) {
      if (!log) return false;
      const st = (log.trangThai || '').toUpperCase();
      return st === 'TU_CHOI' || st === 'DA_HUY' || st === 'HUY';
    },

    formatCurrency,
    formatDateTime,
    shortDate(iso) {
      if (!iso) return '';
      try {
        const d = new Date(iso);
        const dd = String(d.getDate()).padStart(2, '0');
        const mm = String(d.getMonth() + 1).padStart(2, '0');
        return `${dd}/${mm} ${String(d.getHours()).padStart(2, '0')}:${String(
          d.getMinutes(),
        ).padStart(2, '0')}`;
      } catch {
        return formatDateTime(iso);
      }
    },

    getGpsRange() {
  // Không có log thì khỏi tính
  const logs = (this.logs || []).filter(l => l && l.ngayDo);
  if (!logs.length) return null;

  // sort theo thời gian tăng dần
  const sorted = [...logs].sort((a, b) => {
    const ta = new Date(a.ngayDo || 0).getTime();
    const tb = new Date(b.ngayDo || 0).getTime();
    return ta - tb;
  });

  // START: ngày log đầu (vd 2025-11-03T...)
  const start = new Date(sorted[0].ngayDo);

  // END:
  let end;
  if (this.tonDau && this.tonDau.ngayChot) {
    // có chốt dầu dư -> dùng ngày chốt (vd 2025-11-30)
    end = new Date(this.tonDau.ngayChot + 'T23:59:59');
  } else {
    // chưa chốt -> dùng ngày log cuối cùng trong kỳ
    end = new Date(sorted[sorted.length - 1].ngayDo);
  }

  return { start, end };
},


    toYmd(d) {
      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const dd = String(d.getDate()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}`;
    },

    initCurrentMonthRange() {
      const now = new Date();
      const y = now.getFullYear();
      const m = now.getMonth();
      const first = new Date(y, m, 1);
      const last = new Date(y, m + 1, 0);
      this.monthInput = `${y}-${String(m + 1).padStart(2, '0')}`;
      this.filters.tuNgay = this.toYmd(first);
      this.filters.denNgay = this.toYmd(last);
    },

    setFilterMode(mode) {
      this.filterMode = mode;
      if (mode === 'MONTH') this.onMonthChange();
    },

    onMonthChange() {
      if (!this.monthInput) {
        this.filters.tuNgay = null;
        this.filters.denNgay = null;
        return;
      }
      const parts = this.monthInput.split('-');
      if (parts.length !== 2) return;
      const year = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10);
      if (!year || !month) return;
      const first = new Date(year, month - 1, 1);
      const last = new Date(year, month, 0);
      this.filters.tuNgay = this.toYmd(first);
      this.filters.denNgay = this.toYmd(last);
    },

    changeMonth(offset) {
      if (!this.monthInput) return this.initCurrentMonthRange();
      const [yStr, mStr] = this.monthInput.split('-');
      let y = parseInt(yStr, 10);
      let m = parseInt(mStr, 10);
      if (!y || !m) return;
      m += offset;
      if (m < 1) {
        m = 12;
        y -= 1;
      } else if (m > 12) {
        m = 1;
        y += 1;
      }
      this.monthInput = `${y}-${String(m).padStart(2, '0')}`;
      this.onMonthChange();
      this.refreshAll();
    },

    // Tính km fallback theo ODO: group theo xe, sort theo thời gian
    calcPerLogKm(list) {
      const groups = {};
      const map = {};

      list.forEach((log) => {
        if (!log || !log.id || !log.xeBienSo) return;
        const key = (log.xeBienSo || '').replace(/\s|\./g, '');
        if (!groups[key]) groups[key] = [];
        groups[key].push(log);
      });

      Object.values(groups).forEach((arr) => {
        arr.sort((a, b) => {
          const ta = new Date(a.ngayDo || 0).getTime();
          const tb = new Date(b.ngayDo || 0).getTime();
          if (ta !== tb) return ta - tb;
          return (a.id || 0) - (b.id || 0);
        });

        for (let i = 0; i < arr.length; i++) {
          const cur = arr[i];
          const next = arr[i + 1];
          let km = 0;
          if (next) {
            const curO = Number(cur.odoKmCuoiKy || 0);
            const nextO = Number(next.odoKmCuoiKy || 0);
            km = nextO - curO;
            if (!Number.isFinite(km) || km < 0) km = 0;
          } else {
            km = 0;
          }
          map[cur.id] = km;
        }
      });

      return map;
    },

    // Km dùng cho hiển thị & tổng hợp:
    // ưu tiên kmThucTe, chỉ fallback sang perLogKm khi kmThucTe = 0 / null
    getKmForLog(log) {
      if (!log) return 0;
      let km = Number(log.kmThucTe || 0);
      if (!Number.isFinite(km) || km <= 0) {
        km = Number(this.perLogKm[log.id] || 0);
      }
      if (!Number.isFinite(km) || km < 0) km = 0;
      return km;
    },

    // Tính summary gốc theo tổng lít (chưa trừ tồn)
    calcSummary(list) {
      const KM_PER_LITER = 4;
      const res = {
        soLanDo: 0,
        tongTien: 0,
        tongLit: 0,
        tongKmDaDi: 0,
        tongKmPhaiDi: 0,
        tongKmDinhVi: 0,      // đã có
        soLanGiaoHang: 0,
        soLanLayHang: 0,
        kmPerLit: 0,
      };

  if (!Array.isArray(list) || !list.length) return res;

  list.forEach((log) => {
    if (!log) return;
    res.soLanDo += 1;

    const soTien = Number(log.soTien || 0);
    const soLit = Number(log.soLit || 0);
    const km = this.getKmForLog(log);

    // Km định vị (BE nên trả log.kmDinhVi hoặc tương đương)
    const kmDinhVi = Number(log.kmDinhVi || 0);

    res.tongTien += soTien;
    res.tongLit += soLit;
    res.tongKmDaDi += km;
    res.tongKmPhaiDi += soLit * KM_PER_LITER;
    res.tongKmDinhVi += Number.isFinite(kmDinhVi) ? kmDinhVi : 0;
  });

  res.kmPerLit = res.tongLit > 0 ? res.tongKmDaDi / res.tongLit : 0;
  return res;
},


    async refreshAll() {
      this.isLoadingSummary = true;
      this.logs = [];
      this.perLogKm = {};
      this.totalLogs = 0;
  this.tonDau = null;

      try {
        const params = {
          xeId: this.filters.xeId,
          tuNgay: this.filters.tuNgay,
          denNgay: this.filters.denNgay,
          trangThai: null,
          page: 0,
          size: 2000,
        };

        let all = [];
        // loop page
        while (true) {
          const data = await XangDauApi.listLogs(params);
          const content = data.content || [];
          all = all.concat(content);
          const totalPages = data.totalPages ?? 1;
          const currentPage = data.number ?? params.page;
          if (currentPage >= totalPages - 1) break;
          params.page = currentPage + 1;
        }

        // 1) bỏ đơn đã hủy / từ chối
        let valid = all.filter((log) => !this.isCanceled(log));

        // 2) bỏ log chốt tồn (1 lít, 1 đồng) – không tính vào báo cáo
        valid = valid.filter((log) => !this.isChotTonLog(log));

        this.logs = valid;
        this.totalLogs = valid.length;
        this.perLogKm = this.calcPerLogKm(valid);
     this.summaryBase = this.calcSummary(valid);

    const xeId = this.filters.xeId;
    if (xeId) {
      try {
        const denNgayTon = this.filters.denNgay || null;
        const ton = await XangDauApi.getTonDau(xeId, denNgayTon);
        this.tonDau = ton; // <<< GIỮ LẠI NGÀY CHỐT

        const tonCuoiLit = Number(ton?.tonDauLit ?? 0);
        const tongLit = Number(this.summaryBase.tongLit || 0);
        const tongLitThucDung = Math.max(tongLit - tonCuoiLit, 0);
        const kmPerLit =
          tongLitThucDung > 0
            ? this.summaryBase.tongKmDaDi / tongLitThucDung
            : 0;

        this.summaryBase = {
          ...this.summaryBase,
          tongLitThucDung,
          kmPerLit,
        };
      } catch (e) {
        console.error('[BaoCaoXangDauMobile] load ton-dau error', e);
      }
    }

    await this.loadCauData();
    await this.refreshGpsSummary(); // <<< GỌI GPS SAU KHI CÓ LOG + tonDau
  } finally {
    this.isLoadingSummary = false;
  }
},


    exportSummaryExcel() {
      const s = this.summary;
 const rows = [
    ['Chỉ tiêu', 'Giá trị'],
    ['Số lần đổ', s.soLanDo],
    ['Tổng tiền (đ)', s.tongTien],
    ['Tổng lít (L)', s.tongLit],
    ['Tổng lít sử dụng (L)', s.tongLitForCalc],
    ['Tổng Km đã đi (ODO)', s.tongKmDaDi],
    ['Tổng Km định vị (GPS)', s.tongKmDinhVi],
    ['Tổng Km phải đi (quy đổi)', s.tongKmPhaiDi],
    ['Tổng Km cẩu (quy đổi)', s.tongKmCauQuyDoi],
    ['Tổng Km thực tế (chạy + cẩu)', s.tongKmDaDiWithCau],
    ['Hiệu suất Km/L (chỉ ODO)', s.kmPerLit],
    ['Hiệu suất Km/L (bao gồm cẩu)', s.kmPerLitWithCau],
    ['Số lần giao hàng', s.soLanGiaoHang],
    ['Số lần lấy hàng', s.soLanLayHang],
  ];


      const ws = XLSX.utils.aoa_to_sheet(rows);
      ws['!cols'] = [{ wch: 25 }, { wch: 18 }];

      const borderAll = {
        top: { style: 'thin', color: { rgb: 'D9D9D9' } },
        bottom: { style: 'thin', color: { rgb: 'D9D9D9' } },
        left: { style: 'thin', color: { rgb: 'D9D9D9' } },
        right: { style: 'thin', color: { rgb: 'D9D9D9' } },
      };

      const headerStyle = {
        font: { bold: true },
        alignment: { horizontal: 'center', vertical: 'center' },
        fill: { patternType: 'solid', fgColor: { rgb: 'E9ECEF' } },
        border: borderAll,
      };

      const labelStyle = {
        alignment: { horizontal: 'left', vertical: 'center' },
        border: borderAll,
      };

      const valueStyle = {
        alignment: { horizontal: 'right', vertical: 'center' },
        border: borderAll,
        numFmt: '#,##0.0',
      };

      // header
      for (let c = 0; c < 2; c++) {
        const cellRef = XLSX.utils.encode_cell({ r: 0, c });
        if (ws[cellRef]) ws[cellRef].s = headerStyle;
      }

      // body
      for (let r = 1; r < rows.length; r++) {
        const labelCell = XLSX.utils.encode_cell({ r, c: 0 });
        const valueCell = XLSX.utils.encode_cell({ r, c: 1 });

        if (ws[labelCell]) ws[labelCell].s = labelStyle;

        if (ws[valueCell]) {
          const text = rows[r][0] || '';
          let fmt = '#,##0';
          if (
            text.includes('Km') ||
            text.includes('Lít') ||
            text.includes('lít') ||
            text.includes('Km/L')
          ) {
            fmt = '#,##0.0';
          }
          ws[valueCell].s = { ...valueStyle, numFmt: fmt };
        }
      }

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'TongQuan');

      const tu = this.filters.tuNgay || '';
      const den = this.filters.denNgay || '';
      let suffix = '';
      if (tu && den) suffix = `_${tu}_to_${den}`;
      else if (tu) suffix = `_${tu}_from`;
      else if (den) suffix = `__to_${den}`;

      XLSX.writeFile(wb, `bao_cao_xang_dau_mobile${suffix}.xlsx`);
    },
  },

  async mounted() {
    this.initCurrentMonthRange();
    await this.fetchOptionsIfNeeded();
    await this.refreshAll();
  },
};
</script>


<style scoped>
.fuel-report-page {
  background: #f5f6f8;
}

/* Header pills desktop */
.header-stat-pill {
  background: #f8f9fa;
  border-radius: 999px;
  padding: 2px 10px;
  font-size: 11px;
  margin-bottom: 4px;
}
.header-stat-pill .label {
  color: #6c757d;
}
.header-stat-pill .value {
  font-weight: 600;
}

/* Stat cards (mobile-first) */
.stat-card {
  background: #ffffff;
  border-radius: 12px;
  padding: 8px 10px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);
}
.stat-label {
  font-size: 11px;
  color: #6c757d;
}
.stat-value {
  font-size: 16px;
  font-weight: 700;
}
.stat-sub {
  font-size: 11px;
  color: #6c757d;
}

/* Summary table */
.summary-table td {
  padding: 4px 8px;
  font-size: 13px;
}

/* Fuel log card */
.fuel-log-card {
  background: #ffffff;
  border-radius: 10px;
  padding: 8px 10px;
  margin-bottom: 8px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);
}
.log-car {
  font-weight: 600;
}
.log-driver {
  font-size: 11px;
}
.log-money {
  font-weight: 700;
  font-size: 14px;
  color: #dc3545;
}

/* Phiên cẩu */
.cau-session-item {
  border-radius: 8px;
  background: #f8f9fa;
  padding: 6px 8px;
  margin-bottom: 6px;
}

/* bottom nav */
.pb-bottom-nav {
  padding-bottom: 64px;
}
.bottom-nav {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 56px;
  background: #ffffff;
  box-shadow: 0 -1px 4px rgba(0, 0, 0, 0.12);
  display: flex;
  justify-content: space-around;
  align-items: stretch;
  z-index: 1030;
}
.bottom-nav-item {
  flex: 1;
  border: none;
  background: transparent;
  font-size: 11px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #6c757d;
}
.bottom-nav-item i {
  font-size: 16px;
}
.bottom-nav-item.active {
  color: #0d6efd;
}
.bottom-nav-item.active i {
  font-weight: 700;
}

/* Desktop tweaks */
@media (min-width: 768px) {
  .pb-bottom-nav {
    padding-bottom: 0;
  }
}

.cau-img-row {
  display: flex;
  gap: 10px;
}

.cau-img-col {
  flex: 1;
  min-width: 0;
}

.cau-img-label {
  font-size: 11px;
  margin-bottom: 4px;
}

.cau-img {
  width: 100%;
  height: 92px;
  object-fit: cover;
  border-radius: 10px;
  border: 1px solid #e9ecef;
  background: #fff;
  cursor: pointer;
}

.img-modal {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
}

.img-modal-card {
  width: min(560px, 100%);
  background: #fff;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0,0,0,0.25);
}

.img-modal-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  border-bottom: 1px solid #eee;
}

.img-modal-body {
  padding: 12px;
  text-align: center;
}

.img-modal-img {
  width: 100%;
  max-height: 70vh;
  object-fit: contain;
  border-radius: 10px;
  border: 1px solid #f1f3f5;
}

.cau-img-row { display: flex; gap: 10px; }
.cau-img-col { flex: 1; min-width: 0; }
.cau-img-label { font-size: 11px; margin-bottom: 4px; }
.cau-img {
  width: 100%;
  height: 92px;
  object-fit: cover;
  border-radius: 10px;
  border: 1px solid #e9ecef;
  background: #fff;
  cursor: pointer;
}

</style>
